import {ImmutableObject} from "../../utils/immutableObject";
import {EnumOpportunityStatus} from "../enum/enum-opportunity-status";
import {ClientInfos} from './client-informations';

export class QuoteSummary extends ImmutableObject {
    constructor(
        public readonly id?: string,
        public readonly reference?: string,
        public readonly label?: string,
        public readonly totalMonthlyAmount?: string,
        public readonly totalWeeklyAmount?: string,
        public readonly clientInfos?: ClientInfos,
        public readonly status?: EnumOpportunityStatus,
        public readonly creationDate?: Date,
        public readonly cmcProtocolCode?: string,
        public readonly cmcProtocolName?: string,
        public readonly currency?: string,
        public readonly color?: string,
        public readonly offlineId?: string
        ) {
        super();
    }

}